import { render, staticRenderFns } from "./DialogMarketPotential.vue?vue&type=template&id=6158b4bb"
import script from "./DialogMarketPotential.vue?vue&type=script&lang=js"
export * from "./DialogMarketPotential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports